import { Button, Modal } from '@palmetto/palmetto-components';

export const CancelPaymentProposalModal = ({
  isModalOpen,
  handleCloseModal,
  dataIsUpdating,
  updateFunction,
}: {
  isModalOpen: boolean;
  handleCloseModal: () => void;
  dataIsUpdating: boolean;
  updateFunction: () => Promise<void>;
}) => {
  const title = 'Cancel Payment Plan Proposal';
  const confirmationText = 'Are you sure you want to cancel this payment plan proposal?';

  return (
    <Modal ariaLabelledBy="titleBasic" isOpen={isModalOpen} onDismiss={handleCloseModal} maxWidth="5xl">
      <Modal.Header id="titleBasic" title={title} onDismiss={handleCloseModal} />
      <Modal.Body childGap="md" background="secondary">
        {confirmationText}
      </Modal.Body>
      <Modal.Footer justifyContent="space-between">
        <Button
          onClick={handleCloseModal}
          variant="secondary"
          tone="neutral"
          isDisabled={dataIsUpdating}
          isLoading={dataIsUpdating}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          className="shadow-xs"
          onClick={updateFunction}
          style={{ whiteSpace: 'nowrap' }}
          isDisabled={dataIsUpdating}
          isLoading={dataIsUpdating}
        >
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
